module.exports = __webpack_public_path__ + "../resources/img/ic_in_progress.42e6d53d.svg";